import {
  CreditDto,
  CreditRedemptionDto,
  CreditRedemptionEmbeddedVacancy,
  CreditRedemptionViewModel,
  PRODUCT_TRANSLATIONS,
} from '@mkp/shared/models';
import { parseISO } from 'date-fns';
import { toViewModel as toViewModelCredit } from '../credit/credit.mapper';
import { CreditRedemptionUtils } from '@mkp/shared/util-product';

export const toViewModel = <
  TVacancy extends CreditRedemptionEmbeddedVacancy = CreditRedemptionEmbeddedVacancy,
>(
  credit: CreditRedemptionDto<TVacancy>
): CreditRedemptionViewModel<TVacancy> => ({
  id: credit.id,
  start: parseISO(credit.start),
  end: parseISO(credit.end),
  externalId: credit.externalId,
  externalSource: credit.externalSource,
  stoppedAt: credit.stoppedAt ? parseISO(credit.stoppedAt) : null,
  creditId: credit.creditId,
  vacancyId: credit.vacancyId,
  jobHitCount: credit.jobHitCount,
  jobApplicationSentCount: credit.jobApplicationSentCount,
  jobApplicationStartCount: credit.jobApplicationStartCount,
  information: {
    productName:
      PRODUCT_TRANSLATIONS[
        credit._embedded.credit?.product?.type as keyof typeof PRODUCT_TRANSLATIONS
      ]?.longname ?? '',
    productCode: credit._embedded.credit?.product?.type,
    ...CreditRedemptionUtils.getInformation(credit),
  },
  _state: credit._state,
  _version: credit._version,
  _embedded: {
    ...credit._embedded,
    credit: credit._embedded.credit
      ? toViewModelCredit(credit._embedded.credit as CreditDto)
      : undefined,
  },
  _links: credit._links,
});
